// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 698 ? "mediapipe-vision" : chunkId) + "-" + {"401":"5e11a77f4cd36087ce07","698":"efd5fb4b2b06bab42177"}[chunkId] + ".chunk.js";
};